// Free mailbox providers, matched on the first label so country variants (hotmail.co.uk,
// yahoo.fr) count too.
const FREE_PROVIDER = /^(gmail|googlemail|outlook|hotmail|live|msn|yahoo|ymail|icloud|me|mac|aol|proton|protonmail|pm|gmx|mail|yandex|zoho)\./;

// The email's domain when it belongs to a company, or null for free providers and bad input.
export function companyEmailDomain(email: string | null) {
  const domain = email?.split('@')[1]?.toLowerCase();
  return domain && !FREE_PROVIDER.test(domain) ? domain : null;
}
